import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";
import phoneMockup from "../assets/ChatGPT Image Jul 16, 2025, 03_43_36 PM 1.png"; // Replace with your actual path

function DownloadAppSection() {
  return (
    <section className=" download-img-bg">
      <div className="download-bg-overlay text-white ">
        <div className="container">
          <div className="row align-items-center">
            {/* Left content */}
            <div className="col-md-6 text-center py-4 text-md-start mb-4 mb-md-0">
              <h2 className="fw-bold fs-5 display-2 mb-3">
                Download the App Today
              </h2>
              <p className="lead fs-6 col-lg-8 ">
                Make your environment safer—while earning rewards. Join
                thousands of citizens already making a difference.
              </p>

              <div className="d-flex gap-3 mt-4 justify-content-center justify-content-md-start">
                <a href="https://play.google.com/" target="_blank" rel="noopener noreferrer">
                  <img
                    src={googleImg}
                    alt="Get it on Google Play"
                    style={{ height: "48px" }}
                  />
                </a>
                <a href="https://play.google.com/" target="_blank" rel="noopener noreferrer">
                  <img
                    src={appStoreImg}
                    alt="Download on the App Store"
                    style={{ height: "48px" }}
                  />
                </a>
              </div>
            </div>

            {/* Right image */}
            <div className="col-md-6 text-center">
              <img
                src={phoneMockup}
                alt="App Screenshot"
                className="img-fluid"
                style={{ maxHeight: "460px", objectFit: "contain" }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DownloadAppSection;
